import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import { useSelector } from 'react-redux';
import { getFieldOptions } from '../plagins/data/commponentOptions';
import hebrewDate from '../plagins/hebrewDate';
import FormTemplate from '../../template/form/FormTemplate';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import useValidateIsraeliId from '../../template/form/components/validate/useValidateIsraeliId';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { GlobalContext } from '../../../App';
import { v4 as uuidv4 } from 'uuid';
import { addRecordToCache, createFetchDataServer, getTableData, updateRecordInCache } from '../../../database/fetchData';
import { fullSelectedCities, fullSelectedCountries, fullSelectedCustomers } from '../plagins/data/multiSelectedForm';

// הגדרת שם הישות כקבוע
const NAME_ENTITY = 'לקוח';

function CustomerCreate() {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsFormCustomers.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [loading, setLoading] = useState(true); // מצב טעינה

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataCustomer, getEntitiesByAttr, getEntityByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`הוספת לקוח`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [spouse, setSpouse] = useState([]);
  const [showSpouseField, setShowSpouseField] = useState(false);

  const [jerusalemResident, setJerusalemResident] = useState(['956b708e-2c6e-4ae1-8a8e-523104c91753']);
  const [israelResident, setIsraelResident] = useState(['country-auto-0081']);

  useEffect(() => {
    const temp = context?.contextResidencies
    ?.filter( r => r.country === 'country-auto-0081')
    .map( r => {
      return r.city
    })
    setJerusalemResident(temp)
    console.log(1,context?.contextResidencies);
    console.log(2,temp);
    
  }, [context]);



  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      let lock = false;
      let required = true;
      let show = true;
      required = field.name === 'spouse' && formValues.maritalStatus === 2 ? true : field?.required || false;
      show = field.name === 'spouse' && formValues.maritalStatus !== 2 ? false : field?.show || false;
      return {
        ...field,
        disabled: lock ? lock : field.disabled,
        required: required,
        show: show
      };
    });
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    handleAllDataLoaded();
  }, []);

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());

    let initialFormValues = myColumns()
      .filter((field) => field?.name)
      .reduce((acc, field) => {
        // console.log(field.name);
        let fieldValue = '';
        // // כיון שזהוא טופס חדש, אין תאריך וזה רק משמש לתאריך דיפולטיבי
        // if (field.input === 'date') {
        //   fieldValue = format(new Date(), 'yyyy-MM-dd')
        // }
        if (field.name === 'maritalStatus' || field.name === 'association' || field.name === 'statusCustomer') {
          fieldValue = 1;
        }
        return {
          ...acc,
          [field.name]: fieldValue
        };
      }, {});

    if (Object.keys(formValues).length === 0) {
      setFormValues(initialFormValues); // newValues הם הערכים החדשים שברצונך לעדכן
    }

    setCountries(fullSelectedCountries(context?.contextCountries));

    setCities(fullSelectedCities(context?.contextCities));

    setSpouse(fullSelectedCustomers(context?.contextCustomers?.filter((cust) => cust?.maritalStatus !== 2)));
  };

  const [id, setId] = useState('');
  const isValidId = useValidateIsraeliId(id);

  const updateResident = (formValues) => {
    const { typeId, countryId, cityId } = formValues;
    let resident = formValues.resident;

    // בודק אם הוא דרכון
    if (typeId === 2) {
      resident = 3;
    } else if (typeId === 1) {
      // בדיקת מדינה
      if (israelResident?.includes(countryId)) {
        if (jerusalemResident?.includes(cityId)) {
          resident = 1;
        } else {
          resident = 2;
        }
      } else if (countryId && countryId !== null && countryId !== '') {
        resident = 3;
      }
    }

    return { ...formValues, resident };
  };

  const fieldChangeCountryId = (event, newFormValues) => {
    delete newFormValues?.cityId;
    let tempCities = [];

    if (event.target.value !== '') {
      tempCities = getEntitiesByAttr(context?.contextCities, event.target.name, event.target.value);
    } else {
      tempCities = context?.contextCities;
    }
    setCities(fullSelectedCities(context?.contextCities));
  };

  const fieldChangeCityId = (event, newFormValues) => {
    let countryId = newFormValues?.countryId;

    let tempCities = [];

    if (event.target.value !== '') {
      tempCities = getEntitiesByAttr(context?.contextCities, 'unicId', event.target.value);
      const city = getEntityByAttr(context?.contextCities, 'unicId', event.target.value);
      const country = getEntityByAttr(context?.contextCountries, 'unicId', city?.countryId);

      countryId = country?.unicId;
    } else {
      tempCities = getEntitiesByAttr(context?.contextCities, 'countryId', newFormValues?.countryId);
    }
    return { countryId };
  };

  useEffect(() => {
    setFieldsWithDynamicDisabled(myColumns());
  }, [showSpouseField, formValues.maritalStatus, formValues.spouse]);

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    // בדיקה ראשונית אם השדה comment שווה ל-'טעינה'
    if (formValues['comment'] === '888') {
      setErrors({});
      return true;
    }

    fieldsWithDynamicDisabled.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.name === 'numId' && field.notRepeat && formValues[field.name]) {
        if (context?.contextCustomers.some((item) => item[field.name] === formValues[field.name])) {
          if (!value?.unicId) {
            tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
            formIsValid = false;
          }
        }
      }
      if (field.name === 'numId' && formValues[field.name]) {
        if (formValues['typeId'] === 1) {
          if (!isValidId) {
            tempErrors[field.name] = `מספר זהוי ${formValues[field.name]} לא תקין`;
            formIsValid = false;
          }
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleChange = (event) => {
    console.log(event?.target?.name);

    let newFormValues = formValues;
    if (event?.target?.name === 'countryId') {
      fieldChangeCountryId(event, newFormValues);
    }
    if (event?.target?.name === 'cityId') {
      let res = fieldChangeCityId(event, newFormValues);
      if (event.target.value !== '') {
        newFormValues = { ...newFormValues, countryId: res?.countryId };
      }
    }
    if (event?.target?.name === 'numId') {
      setId(event?.target?.value);
    }
    if (event?.target?.name === 'maritalStatus') {
      setFieldsWithDynamicDisabled(myColumns());
      // if (event.target.value === 2) {
      //   setShowSpouseField(true);
      // } else {
      //   setShowSpouseField(false);
      // }
    }
    if (event?.target?.name === 'numId') {
      setId(event?.target?.value);
    }
    if (event?.target?.name === 'dateBirth') {
      let hebrewDateString = '';
      const inputDate = new Date(event.target.value);

      if (!isNaN(inputDate)) {
        hebrewDateString = hebrewDate(inputDate);
      }
      newFormValues = { ...newFormValues, ['dateBirthHe']: hebrewDateString };
    }
    newFormValues = { ...newFormValues, [event.target.name]: event.target.value };
    newFormValues = updateResident(newFormValues);
    setFormValues(newFormValues);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoadingData(true);
      let updatedFormValues = { ...formValues };
      let tempCustomer = { ...formValues,
        countryBirth: '',
        countryBirthId: '',
        countryBirthNameHe: '',
       };

      const unicId = uuidv4();

      let res = await addOrUpdateDataCustomer(formValues, unicId);
      if (res === 200) {
        context?.setContextCustomers((prev) => {
          // חיפוש הערכים
          const existingCustomerIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);
          const existingNewSpouseIndex = prev.findIndex((item) => item.unicId === updatedFormValues.spouse);
          
          if (!updatedFormValues?.typeId || updatedFormValues?.typeId === '' || updatedFormValues?.typeId === null) {
            updatedFormValues = { ...updatedFormValues, typeId: 3 }
          }

          
          // יצירת עותק של המערך
          let updatedState = [...prev];
          
          // עדכון הערכים הקיימים
          if (existingCustomerIndex !== -1) {
            let tempCustomer = { ...updatedState[existingCustomerIndex], ...updatedFormValues};
            updatedState[existingCustomerIndex] = tempCustomer
            updateRecordInCache(tempCustomer, 'dataCustomers')
          } else {
            updatedState.push(updatedFormValues);
            addRecordToCache(updatedFormValues, 'dataCustomers');
          }

          // אם קיים בן זוג חדש
          if (existingNewSpouseIndex !== -1) {
            let tempCustomer = {
              ...updatedState[existingNewSpouseIndex],
              spouse: updatedFormValues.unicId, // קישור ללקוח החדש
              maritalStatus: 2
            };
            updatedState[existingNewSpouseIndex] = tempCustomer
            updateRecordInCache(tempCustomer, 'dataCustomers')
          }

          // החזרת המערך המעודכן
          return updatedState;
        });
        setLoadingData(false);
        navigate(-1);
        fetchDataServer(['customers'], token);
      }
    }
  };

  useEffect(() => {
    //     // מימוש הקולבק
        const handleDataFetched = (fetchedData) => {
          console.log('Fetched Data:', fetchedData);
          setLoading(false);
          // ניתן לבצע פעולות נוספות כאן עם הנתונים המעודכנים
        };
    fetchDataServer(['countries', 'cities'], token, handleDataFetched);
  }, []);

  if (loadingData) return <LoadingOverlay />;

  return (
    <>
      <FormTemplate
        title={`הוספת ${NAME_ENTITY}`}
        btn={`שמור`}
        fields={fieldsWithDynamicDisabled}
        columns={columns}
        formValues={formValues}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        lockUpdate={value !== undefined}
        options={{
          typeId: getFieldOptions('typeId', optionsFields),
          gender: getFieldOptions('gender', optionsFields),
          resident: getFieldOptions('resident', optionsFields),
          maritalStatus: getFieldOptions('maritalStatus', optionsFields),
          association: getFieldOptions('association', optionsFields),
          spouse,
          countryId: countries,
          cityId: cities
        }}
      />
    </>
  );
}

export default CustomerCreate;
